export default "__VITE_ASSET__WFVXY5HM__"